import { render } from "./Dashboard.vue?vue&type=template&id=b64b42ea&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=b64b42ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b64b42ea"

export default script